import { OrganizationProvider, SimRecentSessionsView } from '@hologram-hyper-dashboard/components';
import { getUserContextDataMemoized } from 'common-js/api/util';
import { SIM_DETAILS, USAGE_BY_SESSION } from 'common-js/constants/paths';
import useAppSelector from 'common-js/hooks/useAppSelector';
import { type FC } from 'react';
import SimToLegacyAdapter from '../../sims/containers/SimToLegacyAdapter';

const RecentSessions: FC = () => {
  const userContext = useAppSelector(getUserContextDataMemoized);
  const orgId = userContext.isInOrgContext ? userContext.orgId : userContext.userOrgId;
  return (
    <OrganizationProvider organizationId={orgId}>
      <SimToLegacyAdapter>
        <div className="usage-recent-sessions-container">
          <SimRecentSessionsView
            mode="organization"
            simDetailBaseUrl={SIM_DETAILS}
            usageByRecentSessionUrl={USAGE_BY_SESSION}
            pageSize={250}
          />
        </div>
      </SimToLegacyAdapter>
    </OrganizationProvider>
  );
};

export default RecentSessions;
